<template>
  <svg
    width="101"
    height="100"
    viewBox="0 0 101 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="paw-mid"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5962 87.7056C12.5962 70.2701 34.472 42.7756 50.0977 42.7756C65.528 42.7756 87.5991 70.2701 87.5991 87.7056C87.5991 95.5293 82.3255 99.9999 73.5361 99.9999C68.478 99.9999 64.3473 98.439 60.4521 96.9671C56.977 95.654 53.6893 94.4116 50.0977 94.4116C46.3893 94.4116 43.0329 95.6706 39.5065 96.9935C35.6034 98.4576 31.4918 99.9999 26.4639 99.9999C17.6745 99.9999 12.5962 95.5293 12.5962 87.7056ZM7.32254 28.9166C12.9868 27.3518 19.2371 32.2696 21.1903 40.0932C23.3388 47.9168 20.2137 55.2934 14.5494 56.8581C8.88511 58.4229 2.63486 53.5051 0.681659 45.6815C-1.46686 37.8579 1.65826 30.4813 7.32254 28.9166ZM44.6287 14.6105C46.7772 24.2224 43.8474 33.6107 37.7925 35.399C31.7376 37.1873 24.9014 30.9284 22.5575 21.0929C20.409 11.481 23.3388 2.09266 29.3937 0.304403C35.4486 -1.48386 42.2849 4.77505 44.6287 14.6105ZM78.8097 40.0932C80.7629 32.2696 87.0132 27.3518 92.6775 28.9166C98.3417 30.4813 101.467 37.8579 99.3183 45.6815C97.3651 53.5051 91.1149 58.4229 85.4506 56.8581C79.7863 55.2934 76.6612 47.9168 78.8097 40.0932Z"
      fill="black"
      fill-opacity="0.4"
    />
    <path
      d="M62.2075 35.399C68.2624 37.1873 75.0986 30.9284 77.4425 21.0929C79.591 11.481 76.6612 2.09266 70.6063 0.304403C64.5514 -1.48386 57.7151 4.77505 55.3713 14.6105C53.2228 24.2224 56.1526 33.6107 62.2075 35.399Z"
      fill="black"
      fill-opacity="0.4"
    />
    <path
      id="paw-first"
      opacity="0"
      d="M7.32254 28.9166C12.9868 27.3518 19.2371 32.2696 21.1903 40.0932C23.3388 47.9168 20.2137 55.2934 14.5494 56.8581C8.8851 58.4229 2.63486 53.5051 0.681659 45.6815C-1.46686 37.8579 1.65826 30.4813 7.32254 28.9166Z"
      fill="#F4B400"
    />
    <path
      id="paw-last"
      opacity="0"
      d="M91.9646 28.4893C97.8201 29.5651 101.353 36.8014 99.6872 44.7866C98.1992 52.858 92.0984 58.1944 86.2429 57.1186C80.3875 56.0428 76.8541 48.8065 78.5203 40.8214C80.0084 32.75 86.1092 27.4135 91.9646 28.4893Z"
      fill="#F4B400"
    />
    <path
      id="paw-second"
      opacity="0"
      d="M44.6291 14.6105C46.7776 24.2224 43.8478 33.6108 37.7929 35.399C31.738 37.1873 24.9017 30.9284 22.5579 21.0929C20.4094 11.481 23.3392 2.09266 29.3941 0.304403C35.449 -1.48386 42.2852 4.77505 44.6291 14.6105Z"
      fill="#F4B400"
    />
    <path
      id="paw-third"
      opacity="0"
      d="M78.8339 19.7306C77.0585 29.4671 70.4283 36.8302 63.8131 35.8856C57.198 34.941 53.0599 26.2793 54.7351 16.2542C56.5105 6.51769 63.1408 -0.845366 69.7559 0.0992535C76.3711 1.04387 80.5091 9.70556 78.8339 19.7306Z"
      fill="#F4B400"
    />
  </svg>
</template>
<script setup lang="ts"></script>
